/* eslint-disable */
import React, { useCallback, useRef, useState } from 'react';
import './index.less';
import TriangleActive from '../../../../../../assets/sme/component/triangle-active.png';
import TriangleInactive from '../../../../../../assets/sme/component/triangle-inactive.png';
import SettingsInactive from '../../../../../../assets/sme/component/icon/SettingsInactive.png';
import SettingsActive from '../../../../../../assets/sme/component/icon/Settings.png';
import ShieldInactive from '../../../../../../assets/sme/component/icon/Shieldnactive.png';
import ShieldActive from '../../../../../../assets/sme/component/icon/Shield.png';
import ActivityInactive from '../../../../../../assets/sme/component/icon/ActivityInactive.png';
import ActivityActive from '../../../../../../assets/sme/component/icon/Activity.png';
import FolderPlusInactive from '../../../../../../assets/sme/component/icon/FolderPlusnactive.png';
import FolderPlusActive from '../../../../../../assets/sme/component/icon/FolderPlus.png';
import ImgPoint from '../../../../../../assets/2025/arrow.gif';

const CARD_ICONS = [
  { inactive: SettingsInactive, active: SettingsActive },
  { inactive: ShieldInactive, active: ShieldActive },
  { inactive: ActivityInactive, active: ActivityActive },
  { inactive: FolderPlusInactive, active: FolderPlusActive },
];

export interface ICorrespondingMethodItem {
  id?: string | number;
  title?: string;
  content?: React.ReactNode;
}

export interface ICorrespondingMethodsProps {
  title?: string;
  subTitle?: string;
  items?: ICorrespondingMethodItem[];
  onComplete?: () => void;
  id?: string;
}

const CorrespondingMethods: React.FunctionComponent<
  ICorrespondingMethodsProps
> = ({ title, subTitle, items = [], onComplete, id }) => {
  const [activeIndex, setActiveIndex] = useState(-1);
  const hasCompletedRef = useRef(false);

  const handleClick = useCallback(
    (index: number) => {
      if (activeIndex >= items.length - 1) return;
      if (index !== activeIndex + 1) return;
      setActiveIndex(() => {
        const next = index;
        if (next >= items.length - 1 && !hasCompletedRef.current) {
          hasCompletedRef.current = true;
          setTimeout(() => onComplete?.(), 0);
        }
        return next;
      });
    },
    [activeIndex, items.length, onComplete]
  );

  if (!items.length) return null;

  return (
    <div className="corresponding-methods" id={id}>
      {title && <h3 className="corresponding-methods-title">{title}</h3>}
      {subTitle && <p className="corresponding-methods-subtitle">{subTitle}</p>}
      <div className="corresponding-methods-grid">
        {items.map((item, index) => {
          const isActive = index <= activeIndex;
          return (
            <div
              key={item.id ?? index}
              className={`corresponding-methods-item${
                isActive ? ' is-active' : ''
              }`}
            >
              <div
                className="corresponding-methods-card"
                onClick={() => handleClick(index)}
              >
                <div
                  className="corresponding-methods-card-bg"
                  style={{
                    backgroundImage: `url(${
                      isActive ? TriangleActive : TriangleInactive
                    })`,
                  }}
                />
                <div className="corresponding-methods-card-content">
                  {item.title && (
                    <span className="corresponding-methods-card-title">
                      {item.title}
                    </span>
                  )}
                  <div className="corresponding-methods-card-icon">
                    <img
                      src={
                        isActive
                          ? CARD_ICONS[index % CARD_ICONS.length].active
                          : CARD_ICONS[index % CARD_ICONS.length].inactive
                      }
                      alt=""
                    />
                  </div>
                </div>
              </div>
              <div className="corresponding-methods-line" />
              {index === activeIndex + 1 && (
                <img src={ImgPoint} alt="" className="img-point" />
              )}
              <div className="corresponding-methods-text">{item.content}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default React.memo(CorrespondingMethods);
